import api from '@/services/api'
import store from '../index'

export default {
  state: {
    canEditRegistry: false,
    reloadDetailsRegistry: false,
  },

  mutations: {
    CAN_EDIT_REGISTRY(state, registry) {
      const { nome, isAdmin } = store.getters.user

      if (
        (registry &&
          registry.usuarioCriacao === nome &&
          registry.status === 'Em Aberto') ||
        isAdmin
      ) {
        state.canEditRegistry = true
      } else {
        state.canEditRegistry = false
      }
    },

    SET_RELOAD_DETAILS_REGISTRY(state, payload) {
      state.reloadDetailsRegistry = payload
    },
  },

  actions: {
    async saveRegistry({ commit }, data) {
      try {
        return await api.post('/registries', data)
      } catch (error) {
        throw error
      }
    },

    async getRegistries({ commit }) {
      try {
        const response = await api.get('/registries')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getRegistry({ commit }, registryId) {
      try {
        const response = await api.get(`/registries/${registryId}`)

        const data = response && response.data ? response.data : null
        commit('CAN_EDIT_REGISTRY', data)
        return data
      } catch (error) {
        throw error
      }
    },

    async updateRegistry({ commit }, data) {
      try {
        return await api.put(`/registries/${data.registryId}`, data.registry)
      } catch (error) {
        throw error
      }
    },

    async deleteRegistry({ commit }, registryId) {
      try {
        return await api.delete(`/registries/${registryId}`)
      } catch (error) {
        throw error
      }
    },

    setReloadDetailsRegistry: ({ commit }, status) => {
      commit('SET_RELOAD_DETAILS_REGISTRY', status)
    },
  },

  getters: {
    canEditRegistry: (state) => state.canEditRegistry,
    reloadDetailsRegistry: (state) => state.reloadDetailsRegistry,
  },
}
